import { MapEntityRenderer } from 'app/agriculture/FarmMain/MapRenderer/renderers/MapEntityRenderer';
import { NoteRenderer } from 'app/agriculture/FarmMain/MapRenderer/renderers/custom/NoteRenderer';
import { TaskRenderer } from 'app/agriculture/FarmMain/MapRenderer/renderers/custom/TaskRenderer';
import { HerdRenderer } from 'app/agriculture/FarmMain/MapRenderer/renderers/custom/HerdRenderer';
import { DeviceRenderer } from 'app/agriculture/FarmMain/MapRenderer/renderers/custom/DeviceRenderer';
import { PrimitiveCollectionProvider } from 'app/agriculture/FarmMain/MapRenderer/context/PrimitiveCollectionContext';
import { ProtagAnimalRenderer } from 'app/agriculture/FarmMain/MapRenderer/renderers/custom/ProtagAnimalRenderer';
import { BillboardCollectionProvider } from 'app/agriculture/FarmMain/MapRenderer/context/BillboardCollectionContext';
import { RenderVisibilityWrapper } from 'app/agriculture/FarmMain/MapRenderer/RenderVisibilityWrapper';
import { TankRenderer } from 'app/agriculture/FarmMain/MapRenderer/renderers/custom/TankRenderer';

export const CUSTOM_RENDERERS = [
    { entityType: 'Note', Renderer: NoteRenderer },
    { entityType: 'ProtagAnimal', Renderer: ProtagAnimalRenderer },
    { entityType: 'Task', Renderer: TaskRenderer },
    { entityType: 'Herd', Renderer: HerdRenderer },
    { entityType: 'Device', Renderer: DeviceRenderer },
    { entityType: 'Tank', Renderer: TankRenderer },
] as const;

// Note: the order of this array matters
export const MAP_ENTITIES = [
    { entityType: 'Bridge Crossing', geometryType: 'Point' },
    { entityType: 'Cool Room', geometryType: 'Point' },
    { entityType: 'Gate', geometryType: 'Point' },
    { entityType: 'House', geometryType: 'Point' },
    { entityType: 'Trough', geometryType: 'Point' },
    { entityType: 'Shed', geometryType: 'Point' },
    { entityType: 'Silo', geometryType: 'Point' },
    { entityType: 'Fence', geometryType: 'LineString' },
    { entityType: 'Waterway', geometryType: 'LineString' },
    { entityType: 'Dam', geometryType: 'Polygon' },
    { entityType: 'Erosion Area', geometryType: 'Polygon' },
    { entityType: 'Paddock', geometryType: 'Polygon' },
    { entityType: 'Vegetation', geometryType: 'Polygon' },
    { entityType: 'Yard', geometryType: 'Polygon' },
    { entityType: 'Boundary', geometryType: 'Polygon' },
] as const;

export function MapRenderer() {
    return (
        <PrimitiveCollectionProvider>
            {CUSTOM_RENDERERS.map(({ entityType, Renderer }) => (
                <BillboardCollectionProvider key={entityType}>
                    <RenderVisibilityWrapper type={entityType}>
                        <Renderer />
                    </RenderVisibilityWrapper>
                </BillboardCollectionProvider>
            ))}

            {MAP_ENTITIES.map(({ entityType, geometryType }) => {
                const CollectionProvider =
                    geometryType === 'Point'
                        ? BillboardCollectionProvider
                        : PrimitiveCollectionProvider;

                return (
                    <CollectionProvider key={entityType}>
                        <RenderVisibilityWrapper type={entityType}>
                            <MapEntityRenderer
                                entityType={entityType}
                                geometryType={geometryType}
                            />
                        </RenderVisibilityWrapper>
                    </CollectionProvider>
                );
            })}
        </PrimitiveCollectionProvider>
    );
}
